export const buttonVAlignToKonva = (value: unknown): string => {
  if (typeof value !== 'string') {
    return 'middle';
  }

  switch (value.toUpperCase()) {
    case 'TOP':
      return 'top';
    case 'BOTTOM':
      return 'bottom';
    default:
      return 'middle';
  }
};
